<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import {EditableArea} from "@magnolia/vue-editor";
import CustomMain from "~/templates/areas/CustomMain.vue";
import type {Page, PageWithContent} from "~/types/mgnl";
import {joinURL} from "ufo";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  title?: string;
  authors?: string[];
  abstract?: string;
  metadata: Page;
  header?: Area;
  main: Area;
  footer: Area;
}>();

// Provide the default page title for (child) components
const spineTitleState = useState("spineTitle");

const pathDepth = getPathDepth(props.metadata["@path"]);
let spineTitle = props.title;
if (pathDepth > 2) {
  const maxSecondLevelPath = limitPathDepth(props.metadata["@path"], 2);

  const runtimeConfig = useRuntimeConfig();
  const pagesApi = runtimeConfig.public.mgnl.apiPages;
  const {data: maxSecondLevelContent} = await useMagnoliaFetch<PageWithContent>(
    joinURL(pagesApi, maxSecondLevelPath),
  );
  const maxSecondLevelContentValue = maxSecondLevelContent.value;
  spineTitle =
    maxSecondLevelContentValue?.title ?? maxSecondLevelContentValue?.["@name"];
}
spineTitleState.value = spineTitle ?? "";

provide("page", props.metadata ?? undefined);
provide("authors", props.authors ?? undefined);
provide("abstract", props.abstract ?? undefined);
</script>

<template>
  <EditableArea
    v-if="header"
    :content="header"
    class="content-grid"
    elementType="header"></EditableArea>
  <EditableArea
    v-if="main"
    :content="main"
    :custom-view="CustomMain"
    class="content-grid"
    elementType="main"></EditableArea>
  <EditableArea
    v-if="footer"
    :content="footer"
    class="content-grid mt-auto"
    elementType="footer"></EditableArea>
</template>
<style lang="scss" scoped></style>
